import type { QueryClient } from '@tanstack/react-query';

/**
 * Mark every carbon read of the org stale — the one call for "carbon rows (or
 * the journals they sit on) changed".
 *
 * Covers the Impact register (`['sustainability-activities', orgId]`) AND the
 * server-side totals that the dashboard Planet lens, the Impact / project
 * scope cards and the project/business emissions read:
 * `['carbonSummary', orgId]`, `['carbonEmissionsMonthly', orgId]` and
 * `['carbonEmissions', orgId]` (incl. its `'by-entity'` key). A void changes
 * those totals too (they read `ledger_transactions_live`,
 * docs/TRANSACTION_CLASSIFICATION.md "Live reads"), so every mutation that
 * touched the Impact register before must refresh them as well — calling this
 * keeps the register and the totals from drifting. Only mounted queries
 * refetch, so it is cheap.
 */
export function invalidateCarbonCaches(queryClient: QueryClient, organizationId: string | undefined): void {
  if (!organizationId) return;
  void queryClient.invalidateQueries({ queryKey: ['sustainability-activities', organizationId] });
  void queryClient.invalidateQueries({ queryKey: ['carbonSummary', organizationId] });
  void queryClient.invalidateQueries({ queryKey: ['carbonEmissionsMonthly', organizationId] });
  void queryClient.invalidateQueries({ queryKey: ['carbonEmissions', organizationId] });
}
